<template>
  <div class="number-stepper">
    <button type="button" aria-label="Уменьшить" @click="change(-step)">−</button>
    <input :value="modelValue" type="number" :min="min" :max="max" :step="step" @input="input">
    <button type="button" aria-label="Увеличить" @click="change(step)">+</button>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: { type: [Number, String], default: 0 },
  min: { type: Number, default: 0 },
  max: { type: Number, default: Number.MAX_SAFE_INTEGER },
  step: { type: Number, default: 1 },
})
const emit = defineEmits(['update:modelValue'])
function normalized(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return props.min
  return Math.min(props.max, Math.max(props.min, n))
}
function input(event) { emit('update:modelValue', normalized(event?.target?.value)) }
function change(delta) { emit('update:modelValue', normalized(Number(props.modelValue || 0) + delta)) }
</script>

<style scoped>
.number-stepper{display:grid;grid-template-columns:30px minmax(0,1fr) 30px;height:32px;border:1px solid #292929;border-radius:5px;overflow:hidden;background:#0f0f0f}
.number-stepper button{border:0;background:#171717;color:#dbe4ee;font-size:16px;cursor:pointer}
.number-stepper button:hover{background:#202020}
.number-stepper input{min-width:0;height:30px;border:0!important;border-left:1px solid #292929!important;border-right:1px solid #292929!important;border-radius:0!important;background:#0f0f0f!important;color:#e5e7eb;text-align:center;padding:0 5px!important}
.number-stepper input::-webkit-inner-spin-button,.number-stepper input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}
</style>
